var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.252 5.43924L18.76 11.5692C18.8353 11.6133 18.8978 11.6763 18.9412 11.752C18.9846 11.8277 19.0074 11.9135 19.0074 12.0007C19.0074 12.088 18.9846 12.1737 18.9412 12.2494C18.8978 12.3251 18.8353 12.3882 18.76 12.4322L8.252 18.5622C8.17587 18.6067 8.08935 18.6302 8.0012 18.6304C7.91305 18.6306 7.82642 18.6075 7.75007 18.5634C7.67373 18.5194 7.61039 18.4559 7.56647 18.3795C7.52256 18.3031 7.49963 18.2164 7.5 18.1282V5.87124C7.49998 5.78326 7.52317 5.69684 7.56723 5.62069C7.61129 5.54454 7.67466 5.48136 7.75094 5.43754C7.82723 5.39372 7.91373 5.3708 8.0017 5.3711C8.08968 5.3714 8.17602 5.3949 8.252 5.43924Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStart);
export default __webpack_public_path__ + "static/media/icon_start.551bdb21f52489ab097a2a3542f02157.svg";
export { ForwardRef as ReactComponent };